document.querySelector('.hb_tomos_cta').addEventListener('click', (e) => {
    if(document.querySelector('.hb_tomos_cta').classList.contains('opacity-20')) {
        e.preventDefault();
    }
})

window.doscrollto = (elementId) => {
    const element = document.getElementById(elementId);


    if(elementId == 'hb_tomos') {
        // console.log('doscrollto', elementId);
        document.querySelector('.hb_tomos_cta').classList.remove('opacity-20');
        document.querySelector('.hb_tomos_cta').classList.remove('hidden');
        document.querySelector('.mini_cart_magazines').classList.add('hidden');

        // Get viewport width
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        // Check if viewport width is less than or equal to 768px
        if (viewportWidth <= 768) {
            // If so, scroll to the element
            return;
        }
    }else{
        document.querySelector('.hb_tomos_cta').classList.add('opacity-20');
        document.querySelector('.hb_tomos_cta').classList.add('hidden');
        document.querySelector('.mini_cart_magazines').classList.remove('hidden');
    }


    if (element) {
        const scrollElement = document.querySelector(`#${elementId}`);
        scrollElement.scrollIntoView({
            behavior: 'smooth'
        });
    }
}



window.jQuery(document.body).on('added_to_cart', function(event, fragments, cart_hash, $button) {

        if ($button) {
            const quantity = $button.data('quantity');
            console.log('added_to_cart', quantity);
            document.getElementById('cart_count_magazines').innerHTML = quantity || 0;

            document.querySelector('#mini_cart_magazines').innerHTML = fragments['div.widget_shopping_cart_content'] || '';
            if(quantity > 0) {
                document.querySelector('.mini_cart_magazines').classList.remove('hidden');
            }else{
                document.querySelector('.mini_cart_magazines').classList.add('hidden');
            }
            // You can access product details from the button if needed, e.g.:
        }

});


let moreHotbookElm = document.querySelector('#more-hotbook');
window.moreHotbook = (status) => {
    // console.log('moreHotbook', status);
    moreHotbookElm.classList.add('hidden');
    document.querySelector('body').style.overflow = 'auto';
    if(status == true) {
        moreHotbookElm.classList.remove('hidden');
        document.querySelector('body').style.overflow = 'hidden';
    }
}

let headerNewsletterElm = document.querySelector('#newsletter-form');
window.headerNewsletter = (status) => {
    headerNewsletterElm.classList.add('hidden');
    document.querySelector('body').style.overflow = 'auto';
    if(status == true) {
        headerNewsletterElm.classList.remove('hidden');
        // headerNewsletterElm.style.top = window.scrollY;
        document.querySelector('body').style.overflow = 'hidden';
    }
}

let elmTemas = document.getElementById('Temas');
let newsletterSelectedPills = [];
let newsletterPills = document.querySelectorAll('.list-pills input[type="checkbox"]');
if(newsletterPills) {
    newsletterPills.forEach(_pill => {

        _pill.addEventListener('change', (elm) => {
            if(elm.target.checked) {
                newsletterSelectedPills.push(_pill.value);
            }else {
                newsletterSelectedPills = newsletterSelectedPills.filter(item => item !== _pill.value);
            }
            setSelectedPillsIntoFormInput();
        });

    });

    const setSelectedPillsIntoFormInput = () => {
        let uniqueArray = [...new Set(newsletterSelectedPills)];
        elmTemas.value = uniqueArray.join(",");
    };
}

let headerSearchElm = document.querySelector('#header-search');
window.headerSearch = (status) => {
    // console.log('headerSearch', status);
    headerSearchElm.classList.add('hidden');
    if(status == true) headerSearchElm.classList.remove('hidden');
}

let menuMovilHotbookElm = document.querySelector('#menu-movil-hotbook');
window.menuMovilHotbook = (status) => {
    // console.log('menuMovilHotbook', status);
    menuMovilHotbookElm.classList.add('hidden');
    if(status == true) menuMovilHotbookElm.classList.remove('hidden');
}

